import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import OverlapDesktop from "./OverlapDesktop";
import OverlapMobile from "./OverlapMobile";

function Overlap({ app, config, filter }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <OverlapMobile app={app} config={config} filter={filter} />
  ) : (
    <OverlapDesktop app={app} config={config} filter={filter} />
  );
}

Overlap.defaultProps = {
  app: null,
  config: {},
  filter: "",
};

Overlap.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  filter: PropTypes.string,
};

export default Overlap;
